import { useState } from "react";
import { KeyRound, LogOut, UserCircle2 } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

const ChangePassword = ({ open, onOpenChange }) => {
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const submit = async () => {
    if (f.new_password !== f.confirm) return toast.error("New passwords don't match");
    try {
      await http.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password changed");
      setF({ current_password: "", new_password: "", confirm: "" });
      onOpenChange(false);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#11141E] border-[#2A3245]" data-testid="change-password-dialog">
        <DialogHeader><DialogTitle className="font-display">Change password</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <Input data-testid="current-password-input" type="password" placeholder="Current password" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} />
          <Input data-testid="new-password-input" type="password" placeholder="New password (8+ characters)" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} />
          <Input data-testid="confirm-password-input" type="password" placeholder="Repeat new password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} />
          <Button data-testid="change-password-submit" onClick={submit} disabled={!f.current_password || !f.new_password} className="w-full rounded-full">Save new password</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const AccountMenu = () => {
  const { user, logout } = useAuth();
  const [pw, setPw] = useState(false);
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button data-testid="account-menu-btn" size="sm" variant="ghost" className="rounded-full"><UserCircle2 className="w-4 h-4" /></Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="bg-[#11141E] border-[#2A3245]">
          <DropdownMenuLabel className="text-xs text-slate-400 font-normal" data-testid="account-email">{user?.email}</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem data-testid="change-password-item" onClick={() => setPw(true)}><KeyRound className="w-4 h-4 mr-2" />Change password</DropdownMenuItem>
          <DropdownMenuItem data-testid="logout-item" onClick={logout}><LogOut className="w-4 h-4 mr-2" />Sign out</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <ChangePassword open={pw} onOpenChange={setPw} />
    </>
  );
};
